import './App.css';
import IndexPage from './Pages/IndexPage';

function App() {
  return (
    <div className="App">
      <IndexPage />
    </div>
  );
}

export default App;
